import Vue from 'vue'
import Router from 'vue-router'
const _import = require('@/router/_import_' + process.env.NODE_ENV)

/**
 * [addRoute 添加根菜单]
 * @Author   GJH
 * @DateTime 2018-06-30T21:48:27+0800
 * @_this    {[obj]}                 _this [当前文件的this对象]
 * @code    {[string]}              code  [code
 *                                   多级菜单请传：userManage/docManage]
 * @path	 {[string]}				 文件路径名，默认为index
 */
export default function addRoute(_this,code,path) {
	return new Promise((resolve, reject) => {
		if(JSON.stringify(_this.$store.state.tabs.tabList)
			.indexOf('"code":'+'"'+code+'"') == -1){
			_this.$router.addRoutes(
				[{
					path: '/',
					component: _import('layout/index'),
				    hidden: true,
				    children: [{
					path: code,
                    name: code,
					component: path
		      			?_import(path)
		      			:_import(code + '/index')
				    }]
				}]
			)
		}

		resolve()
	}).catch(error => {
		console.log('error',error)
		reject(error)
	})
}


// WEBPACK FOOTER //
// ./src/utils/pageRouter.js